export enum ETacticMetricForm {
  metric = 'metric',
  period = 'period',
  cycle = 'cycle',
  cycleMeasurement = 'cycleMeasurement',
}
